import React, { useState } from "react";
import { CButton } from "@app/components/Common";
import { COLORS } from "@app/constants";
import { RankItemSection, RankTableText } from "./styles";
import { Text } from "@/styles/reactnative";
import styled from "styled-components";

// 기본 프로필 이미지 (Account 페이지와 동일)
const DEFAULT_PROFILE_IMAGE = '/assets/newHome/account/user-avatar.png';

// 프로필 이미지 URL 생성 함수
const getProfileImageUrl = (item: any): string | null => {
  const imageUrl = item?.profileImage || item?.profile_image || item?.avatar || item?.leaderProfileImage;
  if (!imageUrl) return null;
  if (imageUrl.startsWith('http')) return imageUrl;
  return `${import.meta.env.VITE_APP_API_MEDIA_DEV_URL}/${imageUrl}`;
};

const RankItem = ({ item, index }: any) => {
  const [imageError, setImageError] = useState(false);
  const profileImageUrl = getProfileImageUrl(item);

  // 프로필 이미지 결정: API 이미지 -> 에러 시 기본 이미지
  const displayImageUrl = imageError || !profileImageUrl ? DEFAULT_PROFILE_IMAGE : profileImageUrl;

  return (
    <RankItemSection>
      <RankTableText style={{ width: "40%", flexDirection: "row" }}>
        <RankBadge>{index + 1}</RankBadge>
        <ProfileImageWrapper>
          <ProfileImage
            src={displayImageUrl}
            alt="Profile"
            onError={() => setImageError(true)}
          />
        </ProfileImageWrapper>
        <Text>{item?.english_name}@gmail.com</Text>
      </RankTableText>
      <RankTableText>FTT/USDT</RankTableText>
      <RankTableText>{item?.market}</RankTableText>
      <RankTableText style={{ color: COLORS.lightGreen }}>
        3,467.25%
      </RankTableText>
      <RankTableText>
        <CButton
          title="Action"
          style={{
            border: `1px solid ${COLORS.lightGray}`,
            paddingBlock: 5,
            paddingInline: 20,
          }}
          backgroundHover={COLORS.primary}
          onClick={() => {}}
        />
      </RankTableText>
    </RankItemSection>
  );
};

// Styled Components
const RankBadge = styled.div`
  width: 22px;
  height: 22px;
  background: ${COLORS.lightGray};
  border-radius: 50%;
  color: ${COLORS.gray};
  margin-right: 8px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const ProfileImageWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
  flex-shrink: 0;
  background: ${COLORS.lightGray};
`;

const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export default React.memo(RankItem);
